<template>
    <div>
        <v-card>
            <v-card-title>
            </v-card-title>
            <v-card-text>
                <h2 class="text-center"><span :class="{active: !isLogin}" @click="toLogin">Log In</span> or <span  @click="toRegister" :class="{active: isLogin}">Sign Up</span></h2>
            </v-card-text>
            <v-card-text v-if="isLogin">
                <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field v-model="loginEmail" label="Email*" required></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="loginPassword" label="Password*" type="password" required></v-text-field>
                    </v-flex>
                </v-layout>
                <small>* - required</small>
            </v-card-text>
            <v-card-text v-else>
                <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                        <v-text-field v-model="registerName" label="Name"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="registerEmail" label="Email*" required></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="registerPassword" label="Password*" type="password" required></v-text-field>
                    </v-flex>
                </v-layout>
                <small>* - required</small>
            </v-card-text>        
            <v-card-actions>
                <v-btn color="blue darken-1" @click="clear" text>Clear</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" @click="isLogin ? login() : register()" text>Send</v-btn>
            </v-card-actions>         
        </v-card>
        <cookie-consent :message="message" :linkLabel="linkLabel" :buttonLabel="buttonLabel"/>
    </div>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';
    import helperMixin from '../../helpers/mixin';

    export default {
        name: 'Start',
        data() {
            return {
                isLogin: false,
                loginEmail: '',
                loginPassword: '',                
                registerName: '',                
                registerEmail: '',                
                registerPassword: '',                
                message: "Этот веб-сайт использует файлы cookie, чтобы обеспечить вам наилучший опыт работы на нашем веб-сайте.",
                linkLabel: "Узнать подробнее",   
                buttonLabel: "Ясно"                
            }
        },
        mixins: [helperMixin],
        methods: {
            ...mapActions([
                'logIn',
                'getThemes',
                'getFeeds',
                'signUp'
            ]),
            ...mapMutations(['CLOSE_POPUP', 'SET_ERROR', 'OPEN_POPUP']),            
            clear(){
                if(this.isLogin){
                    this.loginEmail = ''
                    this.loginPassword = ''  
                }else{
                    this.registerName = ''               
                    this.registerEmail = ''               
                    this.registerPassword = '' 
                }
            },           
            toLogin(){
                this.isLogin = true
            },
            toRegister(){
                this.isLogin = false
            },
            async login(){
                try{
                    const res = await this.logIn({email: this.loginEmail, password: this.loginPassword})
                    this.$router.push('/')
                    res && this.CLOSE_POPUP()
                    await this.getThemes({current: true})
                    await this.getFeeds({current: true})                                
                    this.loginRedirects()                                        
                }catch(e){
                    this.SET_ERROR('Login error: ' + e)
                }
            },
            async register(){
                try{
                    await this.signUp({email: this.registerEmail, password: this.registerPassword})
                    this.isLogin = true
                }catch(e){
                    this.SET_ERROR('SignUp error: ' + e)
                }            
            },                      
        }
    }
</script>

<style lang="scss" scoped>
    .active{
        text-decoration: underline;
        cursor: pointer;
        color: cadetblue;
    }
</style>